<autocomplete-list-item (clicked)="triggerEvent()">
  {{ item.name }}
</autocomplete-list-item>
